import { useState, useEffect } from "react";
import { Form, Input, Button } from "antd";
import { Link } from 'react-router-dom';
import Service from '../../service/Auth'

import styled from "styled-components";
import FormControl from "../../component/form/FormControl";

import moment from "moment";
import "moment/locale/th";
moment.locale("th");

const FormExtend = styled(FormControl)`
  .ant-form-item-control-input-content {
    display: flex;
    justify-content: center !important;

    .input-wrapper {
      width: 100%;
      position: relative;
    }

    button {
      margin-left: 10px;
    }

    .count-down {
      top: 25%;
      position: absolute;
      right: 5px;
    }
  }

  .ant-form-item-extra {
    text-align: left;
  }
  .form-item__btn-resend-email {
    background-color: #484c59 !important;

    @media screen and (max-width: 768px) {
      width: 30%;
      font-size: 14px;
      padding-left: 10px !important;
    }

    @media only screen and (max-width: 450px) {
      font-size: 14px;
      width: 30%;
      padding-left: 10px !important;
    }
    @media only screen and (max-width: 376px) {
      font-size: 12px;
      width: 30%;
      padding-left: 10px !important;
    }

    @media screen and (min-width: 1200px) {
      font-size: 1.2vw;
      height: 4.2vw;
    }
  }
`;

export default function FormForgetPassword(props) {
    const [form] = Form.useForm();
    const [countDown, setCountDown] = useState(0);
    const [isSendEmail, setIsSendEmail] = useState(false)
    const [formLoading, setFormLoading] = useState(false)

    useEffect(() => {
        form.setFieldsValue({});
    }, [form]);

    const onFinish = async (values) => {
      setFormLoading(true)
      let result = await Service.forgetPwdSendEmail(values)
      if(result){
        setIsSendEmail(true)
        onResendEmail()
      }
      setFormLoading(false)
    };

    const onResendEmail = () => {
        setCountDown(5);
        for (let i = 0; i <= 5; i++) {
            setTimeout(() => {
                setCountDown(5 - i);
            }, i * 1000);
        }
    };


    const formInput = () => {
        return (
            <>
                <Form.Item
                    name={["email"]}
                    className="form-item__email"
                    label="อีเมล"
                    rules={[{ required: true, type: "email" }]}
                    extra="กรณีไม่ได้รับอีเมล ให้ตรวจสอบใน junk mail"
                >
                    <div className="input-wrapper">
                        <Input/>
                        <span className="count-down">
                            {countDown > 0 ? countDown + " วินาที" : ""}
                        </span>
                    </div>
                </Form.Item>
                <Form.Item className="form-button">
                    <Button 
                      className={`${countDown > 0 ? "btn-primary-secondary" : "btn-primary"}` }  
                      disabled={countDown > 0 ? true : false} 
                      loading={formLoading}
                      htmlType="submit">
                        {isSendEmail ? 'ส่งอีกครั้ง' : 'ยืนยัน'}
                    </Button>
                    <Button
                        className="form-item__btn-submit btn-secondary"
                    ><Link to="/">ยกเลิก</Link>
                    </Button>
                </Form.Item>
            </>
        );
    };

    return (
        <FormExtend
            name={"form-forget-password"}
            column={1}
            inputs={formInput}
            onFinish={props.onFinish ? props.onFinish : onFinish}
            form={form}
            className={props.className ? props.className : ""}
        ></FormExtend>
    );
}
